/*
 * The filter vocabulary Sales Overview reads from the URL. Kept dependency-free
 * so anything that deep-links into the page can share these exact strings
 * without pulling in the page itself.
 */
export const orderStatus = Object.seal(
  Object.freeze({
    ALL: "Order Status",
    INCOMPLETE: "Incomplete",
    COMPLETED: "Completed",
    CANCELLED: "Cancelled",
  }),
);

export const shippingStatus = Object.seal(
  Object.freeze({
    ALL: "Received Status",
    NOT_RECEIVED: "Not Received by Streamily",
    RECEIVED: "Received by Streamily",
  }),
);
